import { QueryClient } from '@tanstack/react-query'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Smart retry: only retry on transient errors (5xx, network failures)
      // Don't retry on client errors (4xx) that won't succeed
      retry: (failureCount, error: any) => {
        if (failureCount >= 2) return false

        if (error?.response?.status >= 400 && error?.response?.status < 500) {
          return false
        }

        // Retry on server errors (5xx) and network failures
        return true
      },
      // Exponential backoff: 1s, 2s, 4s
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
      refetchOnWindowFocus: true,
      staleTime: Infinity,
    },
  },
})
